module.exports = __webpack_public_path__ + "static/img/pic2.6c1e14a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic2.png
// module id = 34Bi
// module chunks = 1